﻿/*---[ ESLint ]---*/
/*
    global occupancyRegion
*/

window.occupancyRegion = function () {
    var LGroupNotActive = "Groep niet actief";
    var PresentationDate = new Date(new Date().toDateString());

    /**
     * Load tree data
     * @param {datetime} selectedDate
     */
    function loadOccupancyRegionNodes(selectedDate) {
        $.ajax({
            type: "GET",
            async: false,
            url: appsettings.getUrl("OccupancyRegion/OccupancyRegionNodes"),
            data: { selectedDate: selectedDate },
            success: function (responseData) {
                if (responseData != undefined) {
                    $('#POccupancy').html(responseData);
                    occupancyRegion.loadNotOccupiedGroups();
                }
            }
        });
    }

    /**
    * Hover current hour with light blue
    * Build popup for total counters
    * @param {Object} e
    * @param {number} hour
    * @param {number} minute
    */
    function hoverCurrentQuarter(e, quarterElement, hour, minute) {
        $('.stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(200, 225, 239, 0.8)');

        if (quarterElement != null) {
            var groupId = quarterElement.parentNode.parentNode.parentNode.id.replace('groupPanel_', '');
            buildPopup(groupId, hour, minute);
        }

        if (e != null) {
            $('#DResult').fadeIn(0);
            if ($('#DResult').length > 0) {
                var treeWidth = ($('#NodeTree')[0]) ? $('#NodeTree')[0].clientWidth : 0;
                var menuWidth = ($('#ModuleMenu')[0]) ? $('#ModuleMenu')[0].clientWidth : 0;
                var popupWidth = ($('#DResult')[0]) ? $('#DResult')[0].clientWidth : 0;
                var headerHight = ($('#headerPane')[0]) ? $('#headerPane')[0].clientHeight : 0;
                var breadcrumbHeight = ($('#BreadcrumbArea')[0]) ? $('#BreadcrumbArea')[0].clientHeight : 0;
                $('#DResult').css({ top: (e.clientY + (e.pageY - e.clientY) - headerHight - breadcrumbHeight) + 'px', left: (e.clientX - treeWidth - menuWidth - popupWidth - 20) + 'px' });
            }
        }
    }

    /**
    * Unhover current hour, color back to normal light grey
    * Hide popup wiht total counters
    * @param {Object} e
    * @param {number} hour
    * @param {number} minute
    */
    function unhoverCurrentQuarter(hour, minute) {
        $('.stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(225, 228, 232, 0.4)');

        $('#DResult').fadeOut(0);
    }

    /**
     * Build pop up wiht total counters from array
     * @param {string} groupId
     * @param {number} hour
     * @param {number} minute
     */
    function buildPopup(groupId, hour, minute) {
        var serviceFunctions = $('#groupPanel_' + groupId + ' div:first-child ul:nth-child(2) li');

        var ih = '<b>Overbezetting:</b>';
        ih += '<div style="display: table-row;">';

        ih += '<div style="display: table-cell;">';
        for (var i = 0, sf; sf = serviceFunctions[i]; i++) {
            ih += '<div>' + sf.children[0].innerHTML + '</div>';
        }
        ih += '</div>';

        ih += '<div style="display: table-cell; text-align: right">';
        for (var i = 0, sf; sf = serviceFunctions[i]; i++) {
            var serviceFunctionId = sf.children[0].id;
            var occupancy = occupancyRegionHours[groupId][serviceFunctionId]['Hour' + hour + zeroPad(minute, 2)];

            if (occupancy == -1) {
                ih += '<div> ' + LGroupNotActive + '</div>';
            } else {
                ih += '<div> ' + occupancy + ' %</div>';
            }
        }
        ih += '</div>';

        ih += '</div>';

        if ($('#DResult').length > 0) {
            $('#DResult')[0].innerHTML = ih;
        }
    }

    /**
    * Zero pad, for minute 0 to 00
    * @param {Object} e
    * @param {number} num
    * @param {number} places
    */
    function zeroPad(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join('0') + num;
    }

    /**
     * Load group data
     * @param {any} groupId
     * @param {any} selectedDate
     */
    function loadGroupData(groupId, selectedDate) {
        $.ajax({
            type: "GET",
            async: false,
            url: appsettings.getUrl("OccupancyRegion/OccupancyRegionGroup"),
            data: { groupId: groupId, selectedDate: selectedDate },
            success: function (responseData) {
                if (responseData != undefined) {
                    refreshDetailsGroup(groupId, responseData.HTMLDetailsGroup);
                    refreshOccupancyHours(groupId, responseData.ServiceFunctions);
                }
            }
        });
    }

    /**
     * Load HTML data in div
     * And set hover to current quarter
     * @param {number} groupId
     * @param {string} htmlData
     */
    function refreshDetailsGroup(groupId, htmlData) {
        $('#groupPanel_' + groupId).html(htmlData);

        occupancyRegion.addHoverFunctions();

        const d = new Date();
        let hour = d.getHours();
        let minute = (d.getMinutes() - (d.getMinutes() % 15)).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        hoverCurrentQuarter(null, null, hour, minute);
    }

    /**
 * Build javascript object array with total counters
 * [groupID][serviceFunctionId][Hour015: 67]
 * @param {any} jsonData
 */
    function refreshOccupancyHours(groupId, jsonData) {
        for (let s = 0; s < jsonData.length; s++) {
            var serviceFunctions = {};

            let { ServiceFunctionID, DayCounters } = jsonData[s];

            var dayData = {};
            for (let q = 0; q < DayCounters.length; q++) {
                let { K, V } = DayCounters[q];

                dayData['Hour' + K] = V;
            }

            serviceFunctions[ServiceFunctionID] = dayData;

            if (occupancyRegionHours[groupId] == null) {
                occupancyRegionHours[groupId] = serviceFunctions;
            } else {
                occupancyRegionHours[groupId] = Object.assign(occupancyRegionHours[groupId], serviceFunctions);
            }
        }
    }

    return {

        /**
         * Page initilization
         * @param {any} selectedDate
         */
        initialize: function (selectedDate, lGroupNotActive) {
            occupancyRegionHours = {};
            LGroupNotActive = lGroupNotActive;
            PresentationDate = selectedDate;

            loadOccupancyRegionNodes(selectedDate);
        },

        /**
         * Calender date changed
         * @param {Object} e
         */
        CSelectedDate_OnChange: function (e) {
            var selectedDate = this.value().toDateString();
            PresentationDate = selectedDate;

            loadOccupancyRegionNodes(selectedDate);
        },

        /**
         * Listbox no occupancy date clicked
         * @param {any} e
         */
        LBNoOccupancyDay_OnClick: function (e) {
            var element = e.sender.select();
            var selectedDate = new Date(e.sender.dataItem(element[0]).Value);
            PresentationDate = selectedDate;

            var calendar = $("#CSelectedDate").data("kendoCalendar");
            calendar.value(selectedDate);

            loadOccupancyRegionNodes(selectedDate.toDateString());
        },


        /**
         * Load all data collapsed/not occupied groups
         * @param {datetime} selectedDate
         */
        loadNotOccupiedGroups: function () {
            var groupPanels = $('[id^=groupPanel_');

            for (var i = 0, gp; gp = groupPanels[i]; i++) {
                var groupId = gp.id.replace('groupPanel_', '');

                /*if(!$('[id^=groupPanel_'+ groupId + '').css('display')) {*/
                if (gp.style.display != 'none') {
                    loadGroupData(groupId, PresentationDate);
                }
            }
        },

        /**
         * Toggle div to show node details
         * @param {any} obj
         */
        toggleNode: function (obj) {
            if (obj.parentNode.getElementsByTagName('div').length > 0) {
                if (obj.src.indexOf('collapse') != -1) {
                    obj.src = obj.src.replace('collapse', 'expand');
                    obj.parentNode.getElementsByTagName('div')[0].style.display = 'none';
                } else {
                    obj.src = obj.src.replace('expand', 'collapse');
                    obj.parentNode.getElementsByTagName('div')[0].style.display = 'block';
                }
            }
        },

        /**
         * Toggle div to show group details
         * @param {any} obj
         */
        toggleGroup: function (obj) {
            if (obj.parentNode.getElementsByTagName('div').length > 0) {
                if (obj.src.indexOf('collapse') != -1) {
                    obj.src = obj.src.replace('collapse', 'expand');
                    obj.parentNode.getElementsByTagName('div')[0].style.display = 'none';
                } else {
                    obj.src = obj.src.replace('expand', 'collapse');
                    obj.parentNode.getElementsByTagName('div')[0].style.display = 'block';

                    var groupPanel = obj.parentNode.lastChild;

                    if (groupPanel.innerHTML == '') {
                        var groupId = groupPanel.id.replace('groupPanel_', '');

                        loadGroupData(groupId, PresentationDate);
                    }
                }
            }
        },

        /**
        * Add hover funtions to every quarter
        */
        addHoverFunctions: function () {
            for (let i = 1; i <= 96; i++) {
                const hour = Math.floor((i - 1) / 4);
                const quarter = ((i - 1) % 4) * 15;

                $('.stripes li:nth-child(' + i + ')').hover(
                    function (e) { hoverCurrentQuarter(e, this, hour, quarter); },
                    function () { unhoverCurrentQuarter(hour, quarter); }
                );
            }
        }
    }
}();